import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

import StringTypeProvider from './data_type_provider/StringTypeProvider.js';
import RoleTypeProvider from './data_type_provider/RoleTypeProvider.js';
import DateTimeTypeProvider from './data_type_provider/DateTimeTypeProvider.js';

const styles = theme => ({

});

const getRowId = row => row.id;
const columns = [
  { name: 'id', title: 'ID' },
  { name: 'name', title: 'Name' },
  { name: 'email', title: 'Email' },
  { name: 'role', title: 'Role' },
  { name: 'createdDateTime', title: 'Created' },
  { name: 'modifiedDateTime', title: 'Modified' },
  { name: 'active', title: 'Active' },
  { name: 'action', title: 'Action' },
];

const ActiveTypeProvider = () => (
  <DataTypeProvider
    for={['active']}
    formatterComponent={({ value }) => <Icon>{ value ? 'check' : 'close' }</Icon>}
    editorComponent={ () => <div /> }
  />
);

class StaffsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      staffs: this.props.staffs,

      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      staffs: Array.from(nextProps.staffs),
    });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return(
      <Paper>
        <Grid
          rows={this.state.staffs}
          getRowId={getRowId}
          columns={columns}>

          <StringTypeProvider for={['email', 'name']} editable={false} />
          <RoleTypeProvider for={['role']} />
          <DateTimeTypeProvider for={['createdDateTime', 'modifiedDateTime']} />
          <ActiveTypeProvider />
          <DataTypeProvider
            for={['action']}
            formatterComponent={({ column, row, value }) => 
              <IconButton onClick={() => this.props.onEditStaff(row)}>
                <Icon>edit</Icon>
              </IconButton>
            }
            editorComponent={() => <div /> }
          />
          
          {/* Sorting */}
          <SortingState />
          <IntegratedSorting />

          <VirtualTable
            columnExtensions={[
              { columnName: 'id', width: 200 },
              { columnName: 'name', width: this.state.width - 261 - 48 - 200 - 200 - 100 - 150 - 150 - 70 - 100 },
              { columnName: 'email', width: 200 },
              { columnName: 'role', width: 100 },
              { columnName: 'createdDateTime', width: 150 },
              { columnName: 'modifiedDateTime', width: 150 },
              { columnName: 'active', width: 80 },
              { columnName: 'action', width: 100 },
            ]}
            height={this.state.height - 112} />
          <TableHeaderRow showSortingControls />

        </Grid>
      </Paper>
    );
  }
}

StaffsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  staffs: PropTypes.array.isRequired,
  onEditStaff: PropTypes.func.isRequired,
};

export default withStyles(styles)(StaffsTable);
